import { useContext, useEffect, useRef } from 'react';
import {
  deliveryOptionsPayWithCashCheckboxClickHandler,
  deliveryOptionsPayWithCashCheckboxHandler,
  getUpdateForCheckoutDetailsAndAnalytics,
  paymentDetailsAnalytics,
  updateCheckoutDetaisLoggedIn,
  addToPaymentClickHandler,
} from 'common/utilities/PaymentUtils';
import { getEnablePaymentCtaForPickupMethod } from 'organisms/Payment/presentation/templates/PaymentViewTemplates';
import { getTenders } from 'common/utilities/content';
import { getPaymentBaseTemplate } from '../presentation/templates/PaymentViewTemplates';
import { PAYMENT_GATEWAYS, PAYMENT_TENDER_TYPES } from 'common/constants/SharedConstants';
import { resetPaymentStatus } from '@kfc-global/react-shared/redux/Actions/PaymentsAction';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { dispatchGetSavedCardDetails } from '../utils/JapanPaymentUtils';
import { getDispositionNew, redirectToOrderProcessingPage } from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
const Payment = props => {
  const { checkoutDetails, updateCheckoutDetails } = props;
  const { dispatch, tender, isPaymentTypeSelected } = checkoutDetails;
  const checkoutDetailsUseRef = useRef(checkoutDetails);
  const { userOrderState } = useContext(UserOrderContext);
  const dispositionNew = getDispositionNew(userOrderState);

  useEffect(() => {
    let updateDetails = { paymentPanelTitle: TRANSLATE_MAPPING_KEY?.ADD_PAYMENT_METHOD_HEADER };
    switch (checkoutDetails?.paymentProvider) {
      case PAYMENT_GATEWAYS.GLOBAL_PAYMENTS:
        updateDetails = {
          enablePayOnArrival: true,
          payOnArrivalAllowedTenders: checkoutDetails?.allowedTenders?.filter(
            item => item === PAYMENT_TENDER_TYPES.PAY_BY_CASH,
          ),
          payNowAllowedTenders: checkoutDetails?.allowedTenders?.filter(
            item => item !== PAYMENT_TENDER_TYPES.PAY_BY_CASH,
          ),
          paymentPanelTitle: TRANSLATE_MAPPING_KEY?.PAYMENT_BY,
        };
        break;
      case PAYMENT_GATEWAYS.PAY_GATE:
      case PAYMENT_GATEWAYS?.JAPAN_PAYMENTS:
        updateDetails = { paymentPanelTitle: TRANSLATE_MAPPING_KEY?.PAYMENT_BY };
        break;
      //no default
    }
    updateCheckoutDetails(updateDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch && dispatch?.(getTenders?.());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    checkoutDetailsUseRef.current = checkoutDetails;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPaymentTypeSelected, tender?.name, tender?.payload]);

  useEffect(() => {
    getUpdateForCheckoutDetailsAndAnalytics(checkoutDetails, updateCheckoutDetails);
    dispatch && dispatch(resetPaymentStatus());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.paymentEnabled]);

  useEffect(() => {
    // console.log(checkoutDetails?.tender?.name)
    checkoutDetails?.tender?.name && paymentDetailsAnalytics(checkoutDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.tender?.name]);

  /*********************************************************************
   *
   * console.debug(new Date().getTime(), ' updateCheckoutDetailsWithCartDataTenantReducer *********> ', checkoutDetails);
   *********************************************************************/
  useEffect(() => {
    checkoutDetails?.userParams?.loggedIn && updateCheckoutDetaisLoggedIn(checkoutDetails, updateCheckoutDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.userFullName?.value, checkoutDetails?.userEmail?.value, checkoutDetails?.userPhone?.value]);

  useEffect(() => {
    if (
      checkoutDetails?.enablePayOnArrival &&
      checkoutDetails?.enablePayByCashOption &&
      !props?.location?.isRetryPaymentErrorEnabled
    ) {
      const checked = deliveryOptionsPayWithCashCheckboxHandler(checkoutDetails, updateCheckoutDetails);
      updateCheckoutDetails({
        // isClickAddPayment: checked,
        isClickPayOnArrival: checked,
        // isPaymentTypeSelected: checked,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.enablePayOnArrival, checkoutDetails?.userOption]);

  useEffect(() => {
    if (checkoutDetails?.enablePayOnArrival && checkoutDetails?.enablePayByCashOption) {
      deliveryOptionsPayWithCashCheckboxClickHandler(checkoutDetails, updateCheckoutDetails);
      updateCheckoutDetails({
        isClickAddPayment: checkoutDetails?.isClickPayOnArrival,
        isPaymentTypeSelected: checkoutDetails?.isClickPayOnArrival,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.isClickPayOnArrival]);

  useEffect(() => {
    if (checkoutDetails?.total !== 0 && checkoutDetails?.showGiftCardOrVoucher) {
      updateCheckoutDetails({
        tender: {
          name: '',
          payload: {},
        },
        enableContinuePayment: false,
        isClickContinuePayment: true,
        isClickAddPayment: false,
        isPaymentTypeSelected: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.total]);

  useEffect(() => {
    if (
      checkoutDetails?.total === 0 &&
      checkoutDetails?.isOrderWithoutPayment &&
      checkoutDetails?.showGiftCardOrVoucher
    ) {
      updateCheckoutDetails({
        enableContinuePayment: false,
        isPaymentTypeSelected: true,
        showPlaceOrderLoading: false,
        isCateringSomeOneElseContactDetailsAreValid: true,
        placeOrderButtonEnabled: true,
        isClickContinuePayment: false,
        tender: {
          name: PAYMENT_TENDER_TYPES.WICODE,
          payload: { name: PAYMENT_TENDER_TYPES.WICODE, amount: checkoutDetails?.total },
          amount: checkoutDetails?.total,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.isOrderWithoutPayment, checkoutDetails?.showGiftCardOrVoucher, checkoutDetails?.total]);
  useEffect(() => {
    checkoutDetails?.isOrderWithoutPayment &&
      checkoutDetails?.orderId &&
      checkoutDetails?.isCreateOrderValidateCompleted &&
      redirectToOrderProcessingPage(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.isCreateOrderValidateCompleted]);

  useEffect(() => {
    checkoutDetails?.isRenderFromRNA && addToPaymentClickHandler(checkoutDetails, updateCheckoutDetails, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.isRenderFromRNA]);

  // useEffect(() => {
  //   checkoutDetails?.isRetryPaymentErrorEnabled &&
  //     updateCheckoutDetails({
  //       isRetryPaymentErrorEnabled: true,
  //       isClickAddPayment: true,
  //       tender: { name: PAYMENT_TENDER_TYPES.CREDIT_CARD, payload: {
  //         name: PAYMENT_TENDER_TYPES.CREDIT_CARD
  //       } },
  //       finalAmount: calculatePrice((checkoutDetails?.cartTotal + checkoutDetails?.driverdeliveryTip), checkoutDetails?.currencyConversionFactor),
  //       lastUsedPaymentMethod: '',
  //     });

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [checkoutDetails?.isRetryPaymentErrorEnabled]);

  /**
   * When logged in or contact info is entered, enable the submit button;
   * if pickup method selection is enabled, check that it is also valid
   */
  useEffect(() => {
    if (checkoutDetails.userParams?.loggedIn || checkoutDetails?.isContactDetailValid) {
      updateCheckoutDetails({
        paymentEnabled: getEnablePaymentCtaForPickupMethod(checkoutDetails),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    checkoutDetails?.userParams?.loggedIn,
    checkoutDetails?.isContactDetailValid,
    checkoutDetails?.collectionPoint?.name,
    checkoutDetails?.collectionPoint?.carNumber,
  ]);

  useEffect(() => {
    checkoutDetails?.paymentProvider === PAYMENT_GATEWAYS?.JAPAN_PAYMENTS &&
      checkoutDetails?.userParams?.loggedIn &&
      dispatchGetSavedCardDetails(props);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.paymentProvider, checkoutDetails?.userParams?.loggedIn]);

  return getPaymentBaseTemplate({ ...props, checkoutDetailsUseRef, dispositionNew });
};

export default Payment;
